export function formatDateToDayMonth(dateStr: string) {
  const date = new Date(dateStr);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date string");
  }

  const day = date.getDate().toString().padStart(2, "0");

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const month = months[date.getMonth()];

  return `${day} ${month}`;
}

export const paymentStatusOptions = [
    "Show All Orders", 
    "Show Paid Orders", 
    "Show Unpaid Orders"
];

export const getPaymentFilterFlags = (filter: string) => {
    if (filter === "Show Paid Orders") {
        return { flag_paid_only: true, flag_not_paid_only: false };
    }
    if (filter === "Show Unpaid Orders") {
        return { flag_paid_only: false, flag_not_paid_only: true };
    }
    return { flag_paid_only: false, flag_not_paid_only: false };
};

export const ORDER_TABLE_COLUMN_COUNT = 10;
export const ORDER_TABLE_SKELETON_ROW_COUNT = 10;
